var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.3 41.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6,17.9c-.1,0-.3,0-.4,0-.5-2.8-2.9-4.9-5.8-4.9s-2.6.4-3.6,1.2c-1.1-1.9-3.1-3.2-5.4-3.2-3.4,0-6.2,2.8-6.2,6.2s0,.4,0,.6c-.1,0-.3,0-.4,0-3.4,0-6.2,2.8-6.2,6.2s2.8,6.2,6.2,6.2h21.8c3.4,0,6.2-2.8,6.2-6.2s-2.8-6.2-6.2-6.2Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.6,27.5h-1.7l-2.9-4.4v4.4h-1.7v-7.2h1.7l2.9,4.4v-4.4h1.7v7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.4,27.1c-.6-.3-1-.8-1.3-1.3-.3-.6-.5-1.2-.5-1.9s.2-1.3.5-1.9c.3-.6.8-1,1.3-1.3.6-.3,1.2-.5,1.9-.5s1.3.2,1.9.5c.6.3,1,.7,1.3,1.3.3.6.5,1.2.5,1.9s-.2,1.3-.5,1.9-.8,1-1.3,1.3c-.6.3-1.2.5-1.8.5s-1.3-.2-1.9-.5ZM23.6,25.4c.3-.4.5-.9.5-1.5s-.2-1.1-.5-1.5-.8-.6-1.4-.6-1,.2-1.4.6c-.3.4-.5.9-.5,1.5s.2,1.1.5,1.5.8.6,1.4.6,1-.2,1.4-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.7,27.5l-.8-1.1-.7,1.1h-1.4l1.3-2.1-1.4-2h1.4l.8,1.1.7-1.1h1.4l-1.4,2.1,1.4,2h-1.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNox);
export default __webpack_public_path__ + "static/media/Nox.30ccbc0c17c793b749f51c919395b92d.svg";
export { ForwardRef as ReactComponent };